import React from "react";
import { ArrowLeftRight } from "lucide-react";

// Poster-style highway direction sign
export default function RouteSignCard({ from, to, tone = "navy", subtitle }) {
  return (
    <div className={`route-sign ${tone==="orange"?"orange":""}`} data-testid={`route-sign-${from}-${to}`}>
      <div className="flex items-center gap-2 font-display font-black tracking-tight text-base sm:text-lg leading-tight">
        <span className="uppercase">{from}</span>
        <ArrowLeftRight className="w-3.5 h-3.5 opacity-80" />
        <span className="uppercase">{to}</span>
      </div>
      {subtitle && <div className="text-[10px] uppercase tracking-widest mt-0.5 opacity-80 leading-tight">{subtitle}</div>}
    </div>
  );
}
